import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { TypeConceptModel } from 'src/app/models/management/type-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TypeConceptTableModel } from 'src/app/models/tables/management/type-concept-table.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { TypeConceptService } from '../../../../services/management/type-concept.service';
import { RegisterTypeConceptComponent } from '../register-type-concept/register-type-concept.component';

@Component({
  selector: 'app-type-concept',
  templateUrl: './type-concept.component.html',
  styleUrls: ['./type-concept.component.scss'],
  standalone: false
})
export class TypeConceptComponent implements OnInit {
  @ViewChild('typeConceptModal') typeConceptModalComponent?: CustomModalComponent | null = null;
  componentRegisterTypeConcept = RegisterTypeConceptComponent;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  data: PagedResponseModel<TypeConceptTableModel> = new PagedResponseModel<TypeConceptTableModel>();
  header: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  inputsForTypeConcept$ = new BehaviorSubject<any>({
    typeConceptModel: new TypeConceptModel,
  });
  limit: number = 10;
  nameWindow: string = 'Tipos Concepto';
  outputForTypeConceptModals$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = "type-concept";
  userAuthenticated: UserModel = new UserModel();

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private typeConceptService: TypeConceptService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    await Promise.all([
      this.getColumnsForConsultation(),
      this.getTypeConceptsForConsultation(),
    ]);
    this.getPermission();
    this.subscription = this.inputsForTypeConcept$.subscribe(async ({ type }) => {
      switch (type) {
        case 'reload':
          await this.getTypeConceptsForConsultation();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async deleteTypeConcept(typeConcept: TypeConceptTableModel) {
    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el tipo concepto "${typeConcept.name}"?`)) {
      try {
        await firstValueFrom(this.typeConceptService.deleteTypeConcept(typeConcept.typeConceptId));
        this.toastHandlerService.showToast(
          'success',
          'El tipo concepto fue eliminado exitosamente.'
        );
        this.getTypeConceptsForConsultation();
      } catch (error) {
        console.error('Error al eliminar el tipo concepto.', error);
      }
    }
  }

  async getColumnsForConsultation() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.typeConceptService.getColumnsForConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getTypeConceptsForConsultation() {
    try {
      this.data = await firstValueFrom(this.typeConceptService.getTypeConceptsForConsultation(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los tipos concepto.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo concepto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.TypeConcept));
  }

  openModalTypeConcept() {
    if (!this.validations()) return;
    this.updateInput(new TypeConceptModel);
  }

  onAction(event: { action: string, item?: TypeConceptTableModel, selectedItems?: number[] }) {
    if (!this.validations()) return;

    if (event.action === 'edit' && event.item) {
      const typeConceptModel = new TypeConceptModel;
      typeConceptModel.typeConceptId = event.item.id;
      typeConceptModel.code = event.item.code;
      typeConceptModel.name = event.item.name;
      this.updateInput(typeConceptModel)
    }
    if (event.action === 'delete' && event.item) {
      this.deleteTypeConcept(event.item);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getTypeConceptsForConsultation();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadList(reload: boolean) {
    if (reload) {
      this.getTypeConceptsForConsultation();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInput(typeConceptContract: TypeConceptModel) {
    this.inputsForTypeConcept$.next({
      typeConceptModel: typeConceptContract,
    });
    this.typeConceptModalComponent && this.typeConceptModalComponent.show();
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar los tipos concepto. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    return true;
  }

}
